import { Box, BoxProps, forwardRef } from '@chakra-ui/react';

import { createUseVariantStyle } from '@bonusly/ds-hooks';

export type HeadingSize = 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

export interface HeadingProps extends BoxProps {
	size?: HeadingSize;
}

const useVariantStyle = createUseVariantStyle({
	size: {
		sm: {
			fontSize: 50,
		},
		md: {
			fontSize: 100,
		},
		lg: {
			fontSize: 150,
		},
		xl: {
			fontSize: 200,
		},
		'2xl': {
			fontSize: 300,
		},
		'3xl': {
			fontSize: 400,
		},
	},
});

const Heading = forwardRef(({ size = 'md', ...rest }: HeadingProps, ref) => {
	const styles = useVariantStyle({ size });

	return <Box as="h2" fontFamily="ui" fontWeight="semibold" letterSpacing="ui" lineHeight="short" ref={ref} {...styles} {...rest} />;
});

Heading.displayName = 'Heading';

export { Heading };
